import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexTwofactor',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const TwoFactorAuthentication = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/twofactor/TwoFactorAuthentication.vue"))
const EmailVerification = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/twofactor/EmailVerification.vue"))
const VerificationCode = defineAsyncComponent(() => import("@/components/theme/forms/formlayout/twofactor/VerificationCode.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Controls",
      mains: "TwoFactor",
      title: "TwoFactor"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(TwoFactorAuthentication)),
        _createVNode(_unref(Card3), {
          colClass: "col-md-12",
          cardbodyClass: "email-verify"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(EmailVerification)),
              _createVNode(_unref(VerificationCode))
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})